import { componentStylesToCss } from '../componentStylesUtils';

const stylesDateFormatter = (componentStyles) => `
  .dateFormatter-wrapper {
    ${componentStylesToCss(componentStyles?.wrapper)}
  }
`;

export default stylesDateFormatter;
